import RichTextBoxReducer from "./rich-textbox-reducer";

export const setValue = (payload) => (dispatch) => {
  dispatch(RichTextBoxReducer.actions.setValue(payload));
};

export const clearValue = () => (dispatch) => {
  dispatch(RichTextBoxReducer.actions.clearValue());
};
